import proptypes from 'prop-types';

const { shape, string, number, bool } = proptypes;

const openCloseShape = shape({
  open: string,
  close: string
});

export const storeShape = shape({
  address: shape({
    city: string,
    postalCode: string,
    state: string,
    street: string,
    country: string
  }),
  distance: string,
  name: string,
  proDeskPhone: string,
  storeDetailsPageLink: string,
  storeId: string,
  storeHours: shape({
    sunday: openCloseShape,
    monday: openCloseShape,
    tuesday: openCloseShape,
    wednesday: openCloseShape,
    thursday: openCloseShape,
    friday: openCloseShape,
    saturday: openCloseShape
  }),
  storeType: string,
  phone: string,
  toolRentalPhone: string
});
